export const generateId = (prefix = '') =>
  `${prefix}${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 8)}`

export const replaceCharacterNames = (obj, shot, formData) => {
  if (typeof obj === 'string') {
    if (!formData.selectedCharacter || !formData.characterList) {
      return obj
    }

    return formData.selectedCharacter.reduce((acc, selected) => {
      const characterName = selected.current.replace(/__/g, '')
      const char = formData.characterList.find(c => c.name === characterName)

      if (char && char.attributes.prompting_name) {
        const promptingName = char.attributes.prompting_name.replace('@', '')
        acc = acc.replace(
          new RegExp(`\\b${char.name}\\b`, 'gi'),
          promptingName
        )
        return acc
      }

      return acc
    }, obj)
  }

  if (typeof obj === 'object' && obj !== null) {
    if (Array.isArray(obj)) {
      return obj.map(item => replaceCharacterNames(item, shot, formData))
    }

    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [
        k,
        replaceCharacterNames(v, shot, formData)
      ])
    )
  }

  return obj
}